function pausableTimer(callback: () => void, delay: number) {
  let timerId: number | null = null;
  let start: number;
  let remaining = delay;

  const pause = () => {
    if (timerId !== null) {
      window.clearTimeout(timerId as number);
      timerId = null;
      remaining -= Date.now() - start;
    }
  };

  const resume = () => {
    if (timerId) {
      return;
    }
    start = Date.now();
    timerId = window.setTimeout(callback, remaining);
  };

  const clear = () => {
    if (timerId !== null) {
      window.clearTimeout(timerId as number);
      timerId = null;
    }
  };

  resume();

  return {
    pause,
    resume,
    clear,
  };
}

export default pausableTimer;
